module.exports = __webpack_public_path__ + "media/images/sports_icons/ski-87cd6162207a2b76a9de6bf3093702b3.png";